// extracted by mini-css-extract-plugin
module.exports = {"dropdown-item":"styles_dropdown-item__1ApUw"};